import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface UserContext {
  userId: string | null;
  companyId: string | null;
  siteId: string | null;
  isLoading: boolean;
}

export const useUserContext = () => {
  const [context, setContext] = useState<UserContext>({
    userId: null,
    companyId: null,
    siteId: null,
    isLoading: true,
  });

  useEffect(() => {
    const fetchContext = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        setContext({ userId: null, companyId: null, siteId: null, isLoading: false });
        return;
      }

      const { data: profile } = await supabase
        .from('worker_profiles')
        .select('company_id, site_id')
        .eq('user_id', user.id)
        .single();

      setContext({
        userId: user.id,
        companyId: profile?.company_id || null,
        siteId: profile?.site_id || null,
        isLoading: false,
      });
    };

    fetchContext();
  }, []);

  return context;
};
